<button
  class="btn btn-primary"
  type="button"
  [disabled]="disabled"
  [attr.ngbAutofocus]="autoFocus ? '' : undefined"
  (click)="click($event)">
  <img [src]="iconSrc" [alt]="iconAlt" height="16" width="16" />
</button>
